import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/dbSelector';
import isOptimizedHallFeatureFlag from '%paysera_seat_selection_integration/js/seatings/Page/components/SeatingMap/service/isOptimizedHallFeatureFlag';

const selectInstantSeatsSelectionFlow = createSelector(
    orm,
    dbSelector,
    ({ Hall }) => {
        return isOptimizedHallFeatureFlag(Hall.all().first()?.optimized);
    },
);

export default selectInstantSeatsSelectionFlow;
